<template>
  <div class="appHeader">
    <div v-if="!NoHeader" class="header noHome">
      <nav>
        <div class="headerLeft">
          <img src="../assets/images/appHeader/logo.png" alt="">
          <span>广州市劳动人事争议仲裁院</span>
        </div>
        <div class="headerRight">
          <div class="headertime">
            <span class="time">{{ date | moment('HH:mm') }}</span>
            <span class="date">{{ date | moment('YYYY/MM/DD') }}</span>
          </div>
          <ul class="headerList">
            <li>
              <router-link to="/">
                <img src="@/assets/images/appHeader/home.png" alt="">
                <span>服务首页</span>
              </router-link>
            </li>
            <li v-if="userInfo">
              <div>
                <img src="@/assets/images/appHeader/person.png" alt="">
                {{ userInfo.memberName }}
              </div>
            </li>
            <li v-if="userInfo">
              <div @click="logout">
                <img src="@/assets/images/appHeader/back.png" alt="">
                退出登录
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <el-dialog
      :visible.sync="logoutTip"
      center
      class="logoutDialog"
      :modal-append-to-body='false'
      :show-close='false'>
      <div class="logout-header">想要退出登录吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logoutTip = false">取 消</el-button>
        <el-button @click="userSureLogout">确 定</el-button>
      </span>
    </el-dialog>
    <tip :showDialog=showTip :tipMessage='tipMessage'></tip>
  </div>
</template>

<script>
import {qw} from '@/utils/qw.js'
import tip from '@/components/tip.vue'
import {getStorageItem, removeStorageItem} from '@/utils/index.js'
import api from '@/api'
import {clearTimeout, setTimeout} from 'timers'
import {momentHandler} from '@/filters/index'
import {mapState} from "vuex";

export default {
  data: function () {
    return {
      NoHeader: false,
      logoutTip: false,
      date: new Date(),
      // loginTitle: '请登录',
      timer: null,
      timerApp: null,
      waitTime: 5,
      dialogVisible: false,
      flag: false,
      form: {
        password: null
      },
      // 非空验证
      showTip: false,
      tipMessage: '请填写密码',
    }
  },
  components: {
    tip
  },
  computed: {
    ...mapState({
      userInfo:state => state.userInfo
    })
  },
  watch: {
    $route(to, form) {
      this.NoHeader = this.$route.meta.NoHeader
    }
  },
  created: function () {
    console.log(this.userInfo)
  },
  mounted() {
    let _this = this
    this.timer = setInterval(() => {
      _this.date = new Date()
    }, 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    // 点击退出登录
    logout() {
      this.logoutTip = true
    },
    // 确认退出
    userSureLogout() {
      this.logoutTip = false
      this.$store.dispatch('getUserInfo', null)
      this.$router.push('/')
    },
  }
}
</script>
<style lang="scss">
.appHeader {
  background: linear-gradient(
      135deg,
      rgba(7, 158, 244, 1) 0%,
      rgba(89, 129, 255, 1) 100%
  );

  .header {
    width: 100%;
    height: 140px;
    padding: 0 22px;

    nav {
      display: flex;
      flex-direction: row;
    }
  }

  .header.noHome {
    background: linear-gradient(
        135deg,
        rgba(7, 158, 244, 1) 0%,
        rgba(89, 129, 255, 1) 100%
    );
  }

  .headerLeft {
    display: flex;
    height: 140px;
    align-items: center;

    img {
      width: 64px;
    }

    span {
      margin-left: 40px;
      font-size: 46px;
      color: #fff;
    }
  }

  .headerRight {
    flex: 1;
    display: flex;
    float: right;
    height: 140px;
    align-items: center;
    justify-content: flex-end;

    .headertime {
      display: flex;
      flex-direction: column;
      color: #fff;
      text-align: center;
      // transform: translateY(-4px);
      .time {
        font-size: 48px;
        line-height: 48px;
        margin-bottom: 6px;
      }

      .date {
        font-size: 24px;
        line-height: 24px;
      }
    }

    .headerList {
      display: flex;
      align-items: center;
      margin-left: 40px;

      li {
        margin: 0 20px;
        cursor: pointer;

        img {
          width: 32px;
          height: 32px;
          margin-bottom: 16px;
        }
      }

      li a,
      li div {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 26px;
        line-height: 26px;
        color: #fff;
        text-decoration: none;
      }
    }
  }

  .logout-app {
    position: fixed;
    top: 0px;
    right: 0px;
    width: 30px;
    height: 30px;
    border-bottom-left-radius: 30px;
    // background: #f40;
    cursor: pointer;
  }

  #dialog-form {
    margin-top: 20px;

    .el-input {
      width: 420px;
    }
  }

  .el-dialog__wrapper {
    position: fixed;
    top: 20%;
    right: 0;
    bottom: 0;
    left: 50%;
    overflow: auto;
    margin-left: -720px;
    width: 1440px;
  }

  .logoutDialog {
    display: flex;
    flex-direction: column;
    align-items: center;

    .el-dialog {
      width: 900px;
      height: 500px;

      .logout-header {
        padding-top: 50px;
        text-align: center;
        font-size: 50px;
        color: #000;
        margin-bottom: 72px;
      }

      .dialog-footer {
        display: flex;
        justify-content: space-around;

        .el-button {
          width: 220px;
        }
      }

      .el-input__inner {
        width: 700px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue